
<template>
    <div class="content-wrapper  " style="background-color:#eee ; height: 100%">
        <div class="container">

        <div class="form-group" style="margin-top: 30px">
            <router-link to="/productCategory/list" class="btn btn-default">بازگشت</router-link>
        </div>

        <div class="panel panel-default">
            <div class="panel-heading">افزودن</div>
            <div class="panel-body">
                <form v-on:submit.prevent="saveForm()">

                    <ul v-if="errors && errors.length" class="container ">
                        <li v-for="error of errors[0]" class="text-danger" >

                            <ul >
                                <li v-for="error_message of error" class="text-danger" >
                                    {{error_message}}
                                </li>
                            </ul>

                            <hr>


                        </li>
                    </ul>



                    <div class="row">
                        <div class="col-xs-12 form-group">
                            <label class="control-label">{{ $t('categories') }}</label>
                            <select class="form-control" v-model="item.parent_id" >
                                <option v-if="!product_category.parent_id" v-for="(product_category,index) in productCategories" :value="product_category.id" :key="index">
                                    {{ product_category.title}}
                                </option>
                            </select>
                        </div>
                    </div>


                    <div class="row">
                        <div class="col-xs-12 form-group">
                            <label class="control-label"> عنوان</label>
                            <input type="text" v-model="item.title" class="form-control">
                        </div>
                    </div>
                    <!--<div class="row">-->
                    <!--<div class="col-xs-12 form-group">-->
                    <!--<label class="control-label">تصویر</label>-->
                    <!--<input type="text" v-model="item.image" class="form-control">-->
                    <!--</div>-->
                    <!--</div>-->
                    <div class="row">
                        <div class="col-xs-12 form-group">
                            <label class="control-label">توضیحات</label>
                            <input type="text" v-model="item.description" class="form-control">
                        </div>
                    </div>





                    <div class="row">
                        <div class="col-xs-12 form-group">
                            <button class="btn btn-success">افزودن</button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
    </div>
</template>

<script>





    const auth = {
        headers: {Authorization:'bearer ' + localStorage.getItem('token')}

    };

    export default {
        data: function () {
            return {
                auth: {headers: {Authorization: 'bearer ' + localStorage.getItem('token')}},
                item: {
                    parent_id: null,
                    title: '',
                    image: null,
                    description: ''
                },

                errors: [],
                productCategories:[],

                serviceCategories: []

            }
        },

        mounted () {

            axios
                .get('/api/productCategories', this.auth)
                .then(response => {
                    this.productCategories = response.data.data;

                })
                .catch(error => {
                    console.log(error);
                    this.errored = true
                })

        }


        ,

        methods: {
            saveForm() {
                var app = this;
                var newItem = app.item;
                axios.post('/api/productCategories', newItem , app.auth)
                    .then(function (resp) {
                        app.$router.push({path: '/productCategory/list'});
                        console.log(resp);

                    })
                    .catch(
                        e => {
                            this.errors.push(e.response.data.messages);
                           for (let value of e.response.data.messages_fa) {
//                        for (let error of Object.entries(value[1])) {
//                            console.log(app.object.entries(app.errors[0]));

                            app.$snotify.warning(value,
                                {
                                    timeout: 7000,
//                                    showProgressBar: false,
                                    closeOnClick: true,
                                    pauseOnHover: true
                                });

//                        }
                        }

                        }

                    );


            }
        }
    }
</script>
